import type {
    ComponentStageData,
    MobileAlgoPlugin,
    MobileAlgoPluginInitializationArgs,
    PluginContext,
    PluginHeuristicsRegistry
} from '../../types'
import {hideComponentsHeuristics, keepHiddenHeuristics} from './heuristicDefinition'
import {createAdaptiveHeuristic, findHeuristic} from '../common'

export const createPlugin = ({stages, readOnlyExtensionAPI}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const hideComponents = (componentStageData: ComponentStageData, contextHelper: PluginContext) => {
        const heuristicToApply = findHeuristic(
            hideComponentsHeuristics,
            componentStageData,
            contextHelper,
            readOnlyExtensionAPI
        )

        if (!heuristicToApply) {
            return
        }

        heuristicToApply.apply(componentStageData)

        return {
            appliedHeuristics: [heuristicToApply.heuristicCode]
        }
    }

    const moveHiddenComponents = (componentStageData: ComponentStageData) => {
        const heuristicToApply = keepHiddenHeuristics.find(({predicate}) => predicate(componentStageData))!

        if (!heuristicToApply) {
            return
        }

        heuristicToApply.apply(componentStageData)

        return {
            appliedHeuristics: [heuristicToApply.heuristicCode]
        }
    }

    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(
            stages.COMPONENT_CATEGORIZATION,
            createAdaptiveHeuristic(hideComponents, moveHiddenComponents)
        )
    }

    return {register, name: 'hide', dependencies: []}
}
